import {Component, OnInit} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import { DispatchGroupCreate } from 'src/app/shared/models/dispatchGroup.model';

@Component({
    selector: 'form-dispatch-group',
    templateUrl: 'form-dispatch-group.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormDispatchGroupComponent implements OnInit {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService) {
    }

    dispatchGroupForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.dispatchGroupForm = new FormGroup({
            'title': new FormControl(null, Validators.required),
            'icon': new FormControl(null, Validators.required)
        });
    }

    onAddRouteGroup() {
        const newDispatchGroup = new DispatchGroupCreate(this.dispatchGroupForm.value.title, this.dispatchGroupForm.value.icon);
        console.log(newDispatchGroup);
        this.dataStorageService.createDispatchGroup(newDispatchGroup);
    }
}
